import type { Draft } from '@reduxjs/toolkit'
import { Currency } from '@mobi/utils/money'
import type { FobSelection, InvestmentType } from '@mobi/betslip/types'
import type { BetSlipBetsState } from '@mobi/betslip/Store/Bets'
import { MAX_INVESTMENT_VALUE, MIN_INVESTMENT_VALUE } from '@mobi/betslip/helpers/constants'

export function updateItemInvestment({
  investmentType,
  value,
  betId,
  state,
}: UpdateItemInvestmentArgs) {
  if (betId === 'Multi') {
    // TODO: handle multi investment
    return
  }

  const selectedItem = state.items.find(item => item.id === betId)
  if (!selectedItem) return

  if (investmentType === 'ReverseStake') {
    const newStake = new Currency(value).divide((selectedItem.selection as FobSelection).winPrice)
    selectedItem.investment.win.value = newStake.value < 0.5 ? 0.5 : newStake.value
    return
  }

  let newValue = new Currency(value).value

  if (newValue >= 0.01 && newValue < MIN_INVESTMENT_VALUE) {
    newValue = MIN_INVESTMENT_VALUE
  }
  if (newValue > MAX_INVESTMENT_VALUE) {
    newValue = MAX_INVESTMENT_VALUE
  }

  if (investmentType === 'Win') {
    selectedItem.investment.win.value = newValue
  }

  if (investmentType === 'Place') {
    selectedItem.investment.place.value = newValue
  }
}

// =====
// Types
// =====

type UpdateItemInvestmentArgs = {
  betId: string
  state: Draft<BetSlipBetsState>
  investmentType: InvestmentType
  value: string
}
